import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

export default function sharpEdgesStyle({ $sharpEdges = false }: ButtonStyleProps) {
  if ($sharpEdges) {
    return css`
      border-radius: 0;
      padding: 0.866666rem 1rem 0.866666rem;

    `;
  }
}
